<div class="container" style="padding-top: 15px;">
  <!-- <ul class="nav justify-content-center">

    <li class="nav-item all">
      <a class="nav-link">All categories</a>
    </li>

    <li class="nav-item" *ngFor="let item of categories" (click)="setCategory(item.id)">
      <a class="nav-link" [routerLink]="'/products/' + item.id" [class.active]="item.id == currentCatogery">{{item.name}}</a>
    </li>
  </ul> -->
  <div class="products-loader">
    <app-loader *ngIf="!products.length"></app-loader>
  </div>

  <div class="row" *ngIf="products.length">
    <div class="col-md-12">
      <div class="row">
        <div
          *ngFor="let item of products; let i = index"
          [preRender]="false"
          (deferLoad)="item.show = true"
          class="col-md-4 col-6"
        >
          <div class="product" [routerLink]="'/product/' + item.id">
            <app-loader *ngIf="item.loading"></app-loader>
            <ng-container *ngIf="item.show">
              <img
                [src]="item.image"
                [hidden]="item.loading"
                (load)="onLoad(i)"
                alt=""
              />
            </ng-container>
            <h3>
              {{ item.name }}
            </h3>
            <div class="overlay"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-pagination
  *ngIf="pagination"
  [pagination]="pagination"
  (pageChanged)="pageChanged($event)"
></app-pagination>
